import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { parse } from 'query-string';
import { LocalStorage } from '../../../../utils/utils';
import { iFMessage } from '../../../../hoc/IntlComponents';
import { array, object, func } from 'prop-types';
import {
  startSetEditProfile,
  startSetProfile,
  startConfirmPhone,
  startRemoveSocialAccount,
  startSetSocialAccount,
} from '../../../../actions/webmaster';
import { startSetAppSettings, startSetSocials } from '../../../../actions/app';
import { openAlert } from '../../../../actions/alerts';
import Layout from '../../../../components/Layout/Layout';
import Card from '../../../../components/Card/Card';
import ProfileEditForm from '../../../../components/Profile/ProfileEditForm';
import AlertModal from '../../../../modals/AlertModal/AlertModal';
import ConfirmSMSModal from '../../../../modals/ConfirmSMSModal/ConfirmSMSModal';
import ProfileNav from '../../components/ProfileNav/ProfileNav';
import { Col } from 'reactstrap';
import ProfileCard from '../../components/ProfileCard/ProfileCard';

class ProfilePage extends Component {
  static propTypes = {
    profile: object.isRequired,
    timezones: array.isRequired,
    startSetEditProfile: func,
    startSetProfile: func,
    startConfirmPhone: func,
  };

  static defaultProps = {
    profile: {},
    timezones: [],
  };

  state = {
    error: false,
    smsModal: false,
    loading: false,
    errors: {},
    phone: '',
    modalType: 'call',
  };

  componentDidMount() {
    const {
      profile: { email },
      intl,
      openAlert,
    } = this.props;
    if (!email.trim().length) {
      openAlert({
        alertType: 'danger',
        message: iFMessage({ intl, id: 'profile.alert.no-email' }),
        dismissable: false,
      });
    }

    this.setState({ loading: true });

    this.props
      .startSetSocials()
      .then(() => this.getAccessData())
      .then(data => this.addSocialAccount(data))
      .then(() => this.setState({ loading: false }));

    this._isMounted = true;
  }

  handleSavePhone = phone => {
    this.sendSMS({ phone });
  };

  toggleSmsModal = () => {
    this.setState(prevState => ({
      smsModal: !prevState.smsModal,
      errors: { ...prevState.errors, phone_confirmation: '' },
    }));
  };

  toggleErrorModal = () => {
    this.setState(prevState => ({ error: !prevState.error }));
  };

  sendSMS = data => {
    this.setState({ loading: true });
    this.props
      .startConfirmPhone(data)
      .then(response => {
        if (data.code) {
          this.props.startSetProfile().then(() => {
            if (this._isMounted) {
              return this.setState(() => ({
                loading: false,
                smsModal: false,
                phone: '',
              }));
            }
          });
        } else {
          const modalType = response?.items[0]?.transport;
          this.setState(() => ({
            smsModal: true,
            phone,
            modalType,
            loading: false,
          }));
        }
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message } = response.data.error;
          if (this._isMounted) {
            if (data.code) {
              this.setState(prevState => ({
                error: true,
                errors: {
                  ...prevState,
                  phone_confirmation: message.message,
                },
                phone: '',
                loading: false,
              }));
            } else {
              this.handleError(message.message);
              this.setState({
                loading: false,
              });
            }
          }
        }
      });
  };

  submit = data => {
    const { timezone, theme } = this.props.profile;

    this.setState(() => ({ loading: true }));

    this.props
      .startSetEditProfile(data)
      .then(() => {
        if ((data.timezone && data.timezone !== timezone) || (data.theme && data.theme !== theme)) {
          window.location.reload();
        }
        return this.props.startSetProfile();
      })
      .then(() => this.props.startSetAppSettings())
      .then(() => this.setState(() => ({ loading: false })));
  };

  handleError = message => {
    this.props.openAlert({
      alertType: 'danger',
      dismissable: false,
      closeInSeconds: 3,
      message,
    });
  };

  handleUnsubscribe = accountId => {
    this.setState({ loading: true });
    const { startRemoveSocialAccount, intl } = this.props;

    startRemoveSocialAccount(accountId)
      .then(() => {
        this.props.openAlert({
          alertType: 'success',
          dismissable: false,
          closeInSeconds: 3,
          message: iFMessage({ intl, id: 'socials.account.disconnected' }),
        });

        this.setState({ loading: false });
      })
      .catch(({ response = {} }) => {
        if (response.data && response.data.error) {
          const { message: error } = response.data.error;
          this.handleError(error.message);
          this.setState({ loading: false });
        }
      });
  };

  getAccounts = () =>
    this.props.accounts.reduce((accounts, acc) => ({ ...accounts, [acc.provider]: acc }), {});

  getSocials = () => Object.values(this.props.socials).map(social => social);

  getAccessData = () => {
    const { hash, search } = this.props.history.location;

    let params = parse(search);

    if (!params.code && !params.error && hash !== '#_=_') {
      params = parse(hash);
    }

    if ((params.access_token || params.code) && params.state) {
      try {
        const { security_hash, provider } = JSON.parse(params.state);
        const { expires_in, user_id } = params;
        const token = params.access_token || params.code;
        const { origin, pathname } = window.location;
        const redirect_uri = `${origin}${pathname}`;

        // сверяется случайное число, генерируемое при подключении, смотреть OFFERRUM-1129
        if (security_hash && security_hash === LocalStorage.get('security_hash')) {
          LocalStorage.remove('security_hash');
          return {
            token,
            expires_in,
            user_id,
            redirect_uri,
            provider,
          };
        } else {
          throw new Error('Security hash is invalid. Probably someone tries to hack you');
        }
      } catch (error) {
        this.handleError('There was an error when receiving an access key.');
        return null;
      }
    } else if (params.error && params.error_description) {
      this.handleError(decodeURIComponent(params.error_description));
    }

    return null;
  };

  removeParams = () => {
    this.props.history.replace(window.location.pathname);
  };

  addSocialAccount = data => {
    if (data !== null) {
      return this.props
        .startSetSocialAccount(data)
        .then(() => {
          const { intl, openAlert } = this.props;
          this.removeParams();
          openAlert({
            alertType: 'success',
            message: iFMessage({ intl, id: 'socials.account.connected' }),
            closeInSeconds: 5,
            dismissable: false,
          });
        })
        .catch(({ response = {} }) => {
          if (response.data && response.data.error) {
            const { message: error } = response.data.error;
            this.handleError(error.message);
          }

          setTimeout(() => {
            this.removeParams();
          }, 3000);
        });
    }
  };

  render() {
    const { loading, error, smsModal, errors, phone, modalType } = this.state;
    const { profile, timezones } = this.props;

    return (
      <Layout formattedTitle="pages.profile.title">
        <Col xs="12">
          <h3 className="page-title">
            <FormattedMessage id="pages.profile.title" defaultMessage="Profile" />
          </h3>
        </Col>
        <Col lg="4">
          <Card>
            <Card.Body>
              <ProfileCard />
            </Card.Body>
          </Card>
          <Card>
            <ProfileNav className="profile-nav" />
          </Card>
        </Col>

        <Col lg="8">
          <Card loading={loading}>
            <Card.Header>
              <FormattedMessage id="account.profile.theme_3" defaultMessage="Bio" />
            </Card.Header>
            <Card.Body>
              <ProfileEditForm
                handleUnsubscribe={this.handleUnsubscribe}
                accounts={this.getAccounts()}
                socials={this.getSocials()}
                submit={this.submit}
                profile={profile}
                timezones={timezones}
                onSavingPhone={this.handleSavePhone}
                updateProfile={this.props.startSetProfile}
              />
            </Card.Body>
          </Card>
        </Col>
        {/* {errors.phone_confirmation && (
          <AlertModal
            className="sms-errors-modal"
            open={error}
            title={<FormattedMessage id="main.error" defaultMessage="Error" />}
            message={errors.phone_confirmation}
            onClose={this.toggleErrorModal}
          />
        )} */}

        <ConfirmSMSModal
          error={errors.phone_confirmation}
          isOpen={smsModal}
          isPhoneCall={modalType === 'call'}
          phone={phone}
          sendSms={this.sendSMS}
          onCancel={this.toggleSmsModal}
          toggleModal={this.toggleSmsModal}
        />
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.webmaster.profile,
  timezones: state.app.globalSettings.timezones,
  socials: state.app.socials,
  accounts: state.webmaster.profile.socials,
});

const mapDispatchToProps = dispatch => ({
  startSetEditProfile: data => dispatch(startSetEditProfile(data)),
  startSetProfile: params => dispatch(startSetProfile(params)),
  startConfirmPhone: data => dispatch(startConfirmPhone(data)),
  startSetAppSettings: () => dispatch(startSetAppSettings()),
  openAlert: params => dispatch(openAlert(params)),
  startRemoveSocialAccount: accountId => dispatch(startRemoveSocialAccount(accountId)),
  startSetSocials: () => dispatch(startSetSocials()),
  startSetSocialAccount: data => dispatch(startSetSocialAccount(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ProfilePage));
